import React from "react"
import { Card, CardContent, CardHeader } from "../../../components/ui/card"
import { Button } from "../../../components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../../components/ui/dropdown-menu"
import { MoreVertical, Eye, Mail, Shield, UserIcon, Calendar, Loader2 } from "lucide-react"

export const UserGridList = ({
    users,
    isLoading,
    getUserAvatar,
    getNameFromEmail,
    handleViewUser,
    handleConfirmationModal,
    resendInvitation,
    getUserTypeBadge,
    getStatusBadge,
    formatDate,
    isDropdownOpen,
    setIsDropdownOpen,
}) => {
    if (isLoading) {
        return (
            <div className="flex justify-center w-full py-4">
                <Loader2 className="animate-spin h-5 w-5 text-gray-500 mx-auto" />
            </div>
        )
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {users.map((user, index) => (
                <Card key={user.id} className="overflow-hidden hover:shadow-md transition-shadow">
                    <CardHeader className="p-4 pb-2 flex flex-row items-start justify-between space-y-0">
                        <div className="flex items-center space-x-3">
                            {getUserAvatar(user.userEmail)}
                            <div>
                                <h3 className="font-semibold">{getNameFromEmail(user.userEmail)}</h3>
                                <p className="text-sm text-gray-500">{user.userEmail}</p>
                            </div>
                        </div>
                        <DropdownMenu onOpenChange={(isOpen) => setIsDropdownOpen(isOpen ? index : null)} open={isDropdownOpen === index}>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" size="icon" className="h-8 w-8">
                                    <MoreVertical className="h-4 w-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuItem onClick={() => handleViewUser(user)}>
                                    <Eye className="h-4 w-4 mr-2" /> View Details
                                </DropdownMenuItem>
                                {user?.notificationStatus !== "Accepted" && (
                                    <DropdownMenuItem
                                        onClick={() => {
                                            setIsDropdownOpen(false);
                                            handleConfirmationModal(true, () => resendInvitation(user.id));
                                        }}>
                                        <Mail className="h-4 w-4 mr-2" /> Resend Invitation
                                    </DropdownMenuItem>
                                )}
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </CardHeader>
                    <CardContent className="p-4 pt-0">
                        <div className="space-y-3 mt-3">
                            <div className="flex items-center text-sm">
                                <Shield className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600">Type: {user.userType}</span>
                            </div>
                            <div className="flex items-center text-sm">
                                <UserIcon className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600">Invited by: {user.invitedFromUserName}</span>
                            </div>
                            <div className="flex items-center text-sm">
                                <Calendar className="h-4 w-4 mr-2 text-gray-500" />
                                <span className="text-gray-600">Invited on: {formatDate(user.createdDate)}</span>
                            </div>
                        </div>
                    </CardContent>
                    <CardContent className="p-4 pt-0 flex justify-between items-center">
                        <div className="flex space-x-2">
                            {getUserTypeBadge(user.roleId)}
                            {getStatusBadge(user.notificationStatus)}
                        </div>
                        <Button
                            variant="ghost"
                            size="sm"
                            className="text-purple-700 hover:text-purple-900"
                            onClick={() => handleViewUser(user)}
                        >
                            <Eye className="h-4 w-4 mr-1" />
                            View
                        </Button>
                    </CardContent>
                </Card>
            ))}
        </div>
    )
}
